import React from 'react';
import { User, Settings, Search, FileText, Folder, HardDrive, Power, LogOut, Gamepad2 } from 'lucide-react';
import { useWindows } from '../contexts/WindowContext';
import Minesweeper from './Minesweeper';

interface StartMenuProps {
  onClose: () => void;
}

const StartMenu: React.FC<StartMenuProps> = ({ onClose }) => {
  const { openWindow } = useWindows();

  const handleProgramClick = (programName: string) => {
    if (programName === 'Minesweeper') {
      openWindow({
        id: 'window-minesweeper-start',
        title: 'Minesweeper',
        content: <Minesweeper />,
        x: Math.random() * 200 + 100,
        y: Math.random() * 100 + 100,
        width: 280,
        height: 350,
      });
    }
    onClose();
  };

  const programs = [
    { name: 'Internet Explorer', icon: Search },
    { name: 'Outlook Express', icon: FileText },
    { name: 'Windows Media Player', icon: FileText },
    { name: 'Paint', icon: FileText },
    { name: 'Notepad', icon: FileText },
    { name: 'Calculator', icon: FileText },
    { name: 'Minesweeper', icon: Gamepad2 },
  ];

  return (
    <>
      <div className="start-menu-overlay" onClick={onClose}></div>
      <div className="start-menu">
        <div className="start-menu-user">
          <div className="user-avatar">
            <User size={32} />
          </div>
          <span className="user-name">User</span>
        </div>
        
        <div className="start-menu-separator"></div>
        
        <div className="start-menu-programs">
          {programs.map((program, index) => (
            <div 
              key={index} 
              className="start-menu-item"
              onClick={() => handleProgramClick(program.name)}
            >
              <program.icon size={16} className="menu-icon" />
              <span>{program.name}</span>
            </div>
          ))}
        </div>
        
        <div className="start-menu-separator"></div>
        
        <div className="start-menu-item">
          <Folder size={16} className="menu-icon" />
          <span>My Documents</span>
        </div>
        
        <div className="start-menu-item">
          <FileText size={16} className="menu-icon" />
          <span>My Recent Documents</span>
        </div>
        
        <div className="start-menu-item">
          <HardDrive size={16} className="menu-icon" />
          <span>My Computer</span>
        </div>
        
        <div className="start-menu-item">
          <Settings size={16} className="menu-icon" />
          <span>Control Panel</span>
        </div>
        
        <div className="start-menu-item">
          <Search size={16} className="menu-icon" />
          <span>Search</span>
        </div>
        
        <div className="start-menu-separator"></div>
        
        <div className="start-menu-bottom">
          <div className="start-menu-item">
            <LogOut size={16} className="menu-icon" />
            <span>Log Off</span>
          </div>
          <div className="start-menu-item">
            <Power size={16} className="menu-icon" />
            <span>Turn Off Computer</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default StartMenu;